module.exports = __webpack_public_path__ + "01_long_brown.9b2418cb.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/mom/layer5/01_long_brown.png
// module id = ieqQ
// module chunks = 0